export const FETCH_PAQUETES_REQUEST = "FETCH_PAQUETES_REQUEST";
export const FETCH_PAQUETES_SUCCESS = "FETCH_PAQUETES_SUCCESS";
export const FETCH_PAQUETES_FAILURE = "FETCH_PAQUETES_FAILURE";
